// removed by extract-text-webpack-plugin
module.exports = {"container":"blocks-embed-container","embedContainer":"blocks-embed-embedContainer","withContainer":"blocks-embed-withContainer","inner":"blocks-embed-inner","title":"blocks-embed-title","embed":"blocks-embed-embed","text":"blocks-embed-text","first":"blocks-embed-first"};


//////////////////
// WEBPACK FOOTER
// ./styles/blocks/embed.scss
// module id = 806
// module chunks = 246